import(/* webpackMode: "eager" */ "/app/app/(static)/my-account/page.tsx");
